(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);throw new Error("Cannot find module '"+o+"'")}var f=n[o]={exports:{}};t[o][0].call(f.exports,function(e){var n=t[o][1][e];return s(n?n:e)},f,f.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
(function (global){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.accessibility = accessibility;

var _jquery = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function accessibility() {

  var $navMobile = (0, _jquery2.default)('.secondary-nav-mobile');
  var $navDesktop = (0, _jquery2.default)('.secondary-nav-desktop');

  function handleSecondaryNavHidden() {
    if (window.matchMedia('(min-width: 992px)').matches) {
      $navMobile.each(function () {
        (0, _jquery2.default)(this).attr('aria-hidden', true);
      });
      $navDesktop.each(function () {
        (0, _jquery2.default)(this).attr('aria-hidden', false);
      });
    } else {
      $navMobile.each(function () {
        (0, _jquery2.default)(this).attr('aria-hidden', false);
      });
      $navDesktop.each(function () {
        (0, _jquery2.default)(this).attr('aria-hidden', true);
      });
    }
  }

  (0, _jquery2.default)(window).resize(handleSecondaryNavHidden);
  handleSecondaryNavHidden();
}

}).call(this,typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],2:[function(require,module,exports){
(function (global){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bv_gallery = bv_gallery;

var _jquery = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function bv_gallery() {

  (0, _jquery2.default)('.gallery--bellavita').each(function () {
    var $this = (0, _jquery2.default)(this),
        $currentKey = 0,
        $items = $this.find('.gallery__items').children(),
        bv_gallery_add_items_classes = function bv_gallery_add_items_classes() {
      $items.removeClass().addClass('gallery__item');
      for (var i = 0; i < $items.length; i++) {
        switch (i) {
          case $currentKey - 2:
            (0, _jquery2.default)($items[i]).addClass('first');
            break;
          case $currentKey - 1:
            (0, _jquery2.default)($items[i]).addClass('prev');
            break;
          case $currentKey:
            (0, _jquery2.default)($items[i]).addClass('active');
            break;
          case $currentKey + 1:
            (0, _jquery2.default)($items[i]).addClass('next');
            break;
          case $currentKey + 2:
            (0, _jquery2.default)($items[i]).addClass('last');
            break;
        }
      }
    },
        bv_gallery_move = function bv_gallery_move(direction) {
      if (direction == 'prev') {
        $currentKey = $currentKey == 0 ? $items.length - 1 : $currentKey - 1;
      } else {
        $currentKey = $currentKey < $items.length - 1 ? $currentKey + 1 : 0;
      }
      bv_gallery_add_items_classes();
    },
        bv_append_nav = function bv_append_nav() {
      var nav = '<div class="gallery__nav"> <div data-direction="prev"> <i class="retraitespopulaires-icon retraitespopulaires-icon-2x retraitespopulaires-icon-arrow-thin retraitespopulaires-icon-rotate-180deg"></i> </div> <div data-direction="next"> <i class="retraitespopulaires-icon retraitespopulaires-icon-2x retraitespopulaires-icon-arrow-thin"></i> </div> </div>';

      $this.append(nav);
      $this.find('.gallery__nav div').click(function () {
        bv_gallery_move((0, _jquery2.default)(this).data('direction'), $items);
      });
    };

    bv_append_nav();
    bv_gallery_add_items_classes();
  });
}

}).call(this,typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],3:[function(require,module,exports){
(function (global){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.carousel = carousel;

var _jquery = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* ========================================================================
 * Bootstrap: carousel.js v3.4.0
 * https://getbootstrap.com/docs/3.4/javascript/#carousel
 * ========================================================================
 * Copyright 2011-2018 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

function carousel() {
  'use strict';

  // CAROUSEL CLASS DEFINITION
  // =========================

  var Carousel = function Carousel(element, options) {
    this.$element = (0, _jquery2.default)(element);
    this.$indicators = this.$element.find('.home-carousel-indicators');
    this.options = options;
    this.paused = null;
    this.sliding = null;
    this.interval = null;
    this.$active = null;
    this.$items = null;

    this.options.keyboard && this.$element.on('keydown.bs.carousel', _jquery2.default.proxy(this.keydown, this));

    this.options.pause == 'hover' && !('ontouchstart' in document.documentElement) && this.$element.on('mouseenter.bs.carousel', _jquery2.default.proxy(this.pause, this)).on('mouseleave.bs.carousel', _jquery2.default.proxy(this.cycle, this));
  };

  Carousel.VERSION = '3.4.0';

  Carousel.TRANSITION_DURATION = 600;

  Carousel.DEFAULTS = {
    interval: 5000,
    pause: 'hover',
    wrap: true,
    keyboard: true
  };

  Carousel.prototype.keydown = function (e) {
    if (/input|textarea/i.test(e.target.tagName)) return;
    switch (e.which) {
      case 37:
        this.prev();break;
      case 39:
        this.next();break;
      default:
        return;
    }

    e.preventDefault();
  };

  Carousel.prototype.cycle = function (e) {
    e || (this.paused = false);

    this.interval && clearInterval(this.interval);

    this.options.interval && !this.paused && (this.interval = setInterval(_jquery2.default.proxy(this.next, this), this.options.interval));

    return this;
  };

  Carousel.prototype.getItemIndex = function (item) {
    this.$items = item.parent().children('.item');
    return this.$items.index(item || this.$active);
  };

  Carousel.prototype.getItemForDirection = function (direction, active) {
    var activeIndex = this.getItemIndex(active);
    var willWrap = direction == 'prev' && activeIndex === 0 || direction == 'next' && activeIndex == this.$items.length - 1;
    if (willWrap && !this.options.wrap) return active;
    var delta = direction == 'prev' ? -1 : 1;
    var itemIndex = (activeIndex + delta) % this.$items.length;
    return this.$items.eq(itemIndex);
  };

  Carousel.prototype.to = function (pos) {
    var that = this;
    var activeIndex = this.getItemIndex(this.$active = this.$element.find('.item.active'));

    if (pos > this.$items.length - 1 || pos < 0) return;

    if (this.sliding) return this.$element.one('slid.bs.carousel', function () {
      that.to(pos);
    }); // yes, "slid"
    if (activeIndex == pos) return this.pause().cycle();

    return this.slide(pos > activeIndex ? 'next' : 'prev', this.$items.eq(pos));
  };

  Carousel.prototype.pause = function (e) {
    e || (this.paused = true);

    if (this.$element.find('.next, .prev').length && _jquery2.default.support.transition) {
      this.$element.trigger(_jquery2.default.support.transition.end);
      this.cycle(true);
    }

    this.interval = clearInterval(this.interval);

    return this;
  };

  Carousel.prototype.next = function () {
    if (this.sliding) return;
    return this.slide('next');
  };

  Carousel.prototype.prev = function () {
    if (this.sliding) return;
    return this.slide('prev');
  };

  Carousel.prototype.slide = function (type, next) {
    var $active = this.$element.find('.item.active');
    var $next = next || this.getItemForDirection(type, $active);
    var isCycling = this.interval;
    var direction = type == 'next' ? 'left' : 'right';
    var that = this;

    if ($next.hasClass('active')) return this.sliding = false;

    var relatedTarget = $next[0];
    var slideEvent = _jquery2.default.Event('slide.bs.carousel', {
      relatedTarget: relatedTarget,
      direction: direction
    });
    this.$element.trigger(slideEvent);
    if (slideEvent.isDefaultPrevented()) return;

    this.sliding = true;

    isCycling && this.pause();

    if (this.$indicators.length) {
      this.$indicators.find('.active').removeClass('active');
      var $nextIndicator = (0, _jquery2.default)(this.$indicators.children()[this.getItemIndex($next)]);
      $nextIndicator && $nextIndicator.addClass('active');
    }

    var slidEvent = _jquery2.default.Event('slid.bs.carousel', { relatedTarget: relatedTarget, direction: direction }); // yes, "slid"
    if (_jquery2.default.support.transition && this.$element.hasClass('slide')) {
      $next.addClass(type);
      if ((typeof $next === 'undefined' ? 'undefined' : _typeof($next)) === 'object' && $next.length) {
        $next[0].offsetWidth; // force reflow
      }
      $active.addClass(direction);
      $next.addClass(direction);
      $active.one('bsTransitionEnd', function () {
        $next.removeClass([type, direction].join(' ')).addClass('active');
        $active.removeClass(['active', direction].join(' '));
        that.sliding = false;
        setTimeout(function () {
          that.$element.trigger(slidEvent);
        }, 0);
      }).emulateTransitionEnd(Carousel.TRANSITION_DURATION);
    } else {
      $active.removeClass('active');
      $next.addClass('active');
      this.sliding = false;
      this.$element.trigger(slidEvent);
    }

    isCycling && this.cycle();

    return this;
  };

  // CAROUSEL PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this = (0, _jquery2.default)(this);
      var data = $this.data('bs.carousel');
      var options = _jquery2.default.extend({}, Carousel.DEFAULTS, $this.data(), (typeof option === 'undefined' ? 'undefined' : _typeof(option)) == 'object' && option);
      var action = typeof option == 'string' ? option : options.slide;

      if (!data) $this.data('bs.carousel', data = new Carousel(this, options));
      if (typeof option == 'number') data.to(option);else if (action) data[action]();else if (options.interval) data.pause().cycle();
    });
  }

  var old = _jquery2.default.fn.carousel;

  _jquery2.default.fn.carousel = Plugin;
  _jquery2.default.fn.carousel.Constructor = Carousel;

  // CAROUSEL NO CONFLICT
  // ====================

  _jquery2.default.fn.carousel.noConflict = function () {
    _jquery2.default.fn.carousel = old;
    return this;
  };

  // CAROUSEL DATA-API
  // =================

  var clickHandler = function clickHandler(e) {
    var $this = (0, _jquery2.default)(this);
    var href = $this.attr('href');
    if (href) {
      href = href.replace(/.*(?=#[^\s]+$)/, ''); // strip for ie7
    }
    var target = $this.attr('data-target') || href;
    var $target = (0, _jquery2.default)(document).find(target);
    var indicator = (0, _jquery2.default)(document).find('.home-carousel-indicators');
    var items = document.getElementsByClassName('item');
    for (var i = 0; i < items.length; i++) {
      if (items[i].classList.contains("prev") || items[i].classList.contains("next")) {
        indicator.text(i + 1 + '/' + items.length);
        i = items.length;
      }
    }

    if (!$target.hasClass('carousel')) return;

    var options = _jquery2.default.extend({}, $target.data(), $this.data());
    var slideIndex = $this.attr('data-slide-to');
    if (slideIndex) options.interval = false;

    Plugin.call($target, options);

    if (slideIndex) {
      $target.data('bs.carousel').to(slideIndex);
    }

    e.preventDefault();
  };

  (0, _jquery2.default)(document).on('click.bs.carousel.data-api', '[data-slide]', clickHandler).on('click.bs.carousel.data-api', '[data-slide-to]', clickHandler);

  (0, _jquery2.default)(window).on('load', function () {
    (0, _jquery2.default)('[data-ride="carousel"]').each(function () {
      var $carousel = (0, _jquery2.default)(this);
      Plugin.call($carousel, $carousel.data());
      ResizeCarousel();
    });
  });

  (0, _jquery2.default)(window).on('resize', ResizeCarousel);

  function ResizeCarousel() {
    var carouselContainer = (0, _jquery2.default)(document).find('.carousel-home-container')[0];
    if (carouselContainer != null) {
      if ((0, _jquery2.default)(document).width() < 768) {
        carouselContainer.classList.replace('lg-height-2', 'lg-height-4');
        carouselContainer.classList.replace('md-height-2', 'md-height-4');
      } else {
        carouselContainer.classList.replace('lg-height-4', 'lg-height-2');
        carouselContainer.classList.replace('md-height-4', 'md-height-2');
      }
    }
  }
}

}).call(this,typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],4:[function(require,module,exports){
(function (global){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ckeditor_accordion = ckeditor_accordion;

var _jquery = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * This JS is only use with the CKeditor Accordion module.
 * It adds a div around the head of each tab of the accordion to make the whole head clickable.
 *
 *  @see {@link https://www.drupal.org/project/ckeditor_accordion}
 */
function ckeditor_accordion() {

  (0, _jquery2.default)(document).ready(function () {
    // wait otherwise it's in conflict with the JS of module
    (0, _jquery2.default)('.ckeditor-accordion-container').find('dt').wrapInner("<div class='ckeditor-accordion-toggler'></div>");
    // had no-style class to hide link aspect
    (0, _jquery2.default)('.ckeditor-accordion-container').find('dt').find('a').each(function () {
      (0, _jquery2.default)(this).addClass('no-style');
    });
  });
}

}).call(this,typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],5:[function(require,module,exports){
(function (global){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.datepicker = datepicker;

var _jquery = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function datepicker() {
  var options = {
    language: 'fr',
    format: 'dd/mm/yyyy',
    showOnFocus: false,
    todayHighlight: true
  };

  (0, _jquery2.default)('.datepicker').datepicker(options);

  (0, _jquery2.default)('.datepicker + .input-group-btn').on('click', 'button', function () {
    (0, _jquery2.default)(this).parents('.form-group').find('.datepicker').datepicker('show');
  });

  (0, _jquery2.default)('.datepicker').on('blur', function () {
    (0, _jquery2.default)(this).val((0, _jquery2.default)(this).val().replace(/[^\d]/g, "/"));
  });
}

}).call(this,typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],6:[function(require,module,exports){
(function (global){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gallery = gallery;

var _jquery = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function gallery() {

  // Define click event on gallery item
  (0, _jquery2.default)('.gallery').on('click', 'a', function (event) {

    // Prevent location change
    event.preventDefault();

    // Generate the tree
    var container = [];
    (0, _jquery2.default)('.gallery [itemprop="associatedMedia"]').each(function () {
      var $this = (0, _jquery2.default)(this);
      container.push({
        src: $this.find('a').attr('href'),
        w: $this.find('a').data('width'),
        h: $this.find('a').data('height')
      });
    });

    // Define object and gallery options
    var $pswp = (0, _jquery2.default)('.pswp')[0],
        options = {
      index: (0, _jquery2.default)(this).data('index'),
      bgOpacity: 0.85,
      showHideOpacity: true,
      shareEl: true,
      shareButtons: [{ id: 'download', label: 'Download', url: '{{raw_image_url}}', download: true }]
    };

    // Initialize PhotoSwipe
    var gallery = new PhotoSwipe($pswp, PhotoSwipeUI_Default, container, options);
    gallery.init();
  });
}

}).call(this,typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],7:[function(require,module,exports){
"use strict";

var _mobile_menu = require("./mobile_menu.js");

var _navbar = require("./navbar.js");

var _input_dynamic_label = require("./input_dynamic_label.js");

var _input_files = require("./input_files.js");

var _organicJS = require("./organicJS.js");

var _datepicker = require("./datepicker.js");

var _number_format = require("./number_format.js");

var _smoothscroll = require("./smoothscroll.js");

var _gallery = require("./gallery.js");

var _popover = require("./popover.js");

var _selectize = require("./selectize.js");

var _labels = require("./labels.js");

var _slider = require("./slider.js");

var _bv_gallery = require("./bv_gallery.js");

var _ckeditor_accordion = require("./ckeditor_accordion.js");

var _popin = require("./popin.js");

var _carousel = require("./carousel.js");

var _accessibility = require("./accessibility.js");

(function () {
  (0, _mobile_menu.mobile_menu)();
  (0, _navbar.navbar)();
  (0, _smoothscroll.smoothscroll_load)();
  (0, _input_dynamic_label.input_dynamic_label)();
  (0, _input_files.input_files)();
  (0, _gallery.gallery)();
  (0, _organicJS.organic_generate)();
  (0, _datepicker.datepicker)();
  (0, _number_format.number_format)();
  (0, _popover.popover)();
  (0, _selectize.selectize)();
  (0, _labels.labels)();
  (0, _slider.slider)();
  (0, _bv_gallery.bv_gallery)();
  (0, _ckeditor_accordion.ckeditor_accordion)();
  (0, _popin.popin)();
  (0, _carousel.carousel)();
  (0, _accessibility.accessibility)();
})();

},{"./accessibility.js":1,"./bv_gallery.js":2,"./carousel.js":3,"./ckeditor_accordion.js":4,"./datepicker.js":5,"./gallery.js":6,"./input_dynamic_label.js":8,"./input_files.js":9,"./labels.js":10,"./mobile_menu.js":11,"./navbar.js":12,"./number_format.js":13,"./organicJS.js":14,"./popin.js":15,"./popover.js":16,"./selectize.js":17,"./slider.js":18,"./smoothscroll.js":19}],8:[function(require,module,exports){
(function (global){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.input_dynamic_label = input_dynamic_label;

var _jquery = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function input_dynamic_label() {

  (0, _jquery2.default)(document).on('keypress', '.form-group input', function () {
    var $this = (0, _jquery2.default)(this),
        $group = $this.parents('.form-group'),
        $label = $group.find('label');

    // Check the label is empty and value isn't
    if ($this.val().length == 0 && $label.html().length == 0) {
      $label.toggleClass('label-hidden');
      $label.html($this.attr('data-title'));
    }
  });
}

}).call(this,typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],9:[function(require,module,exports){
(function (global){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.input_files = input_files;

var _jquery = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function input_files() {

  (0, _jquery2.default)('.form-file').each(function () {
    var $handler = (0, _jquery2.default)(this).find('.form-file-handler'),
        $this = (0, _jquery2.default)(this),
        $input = (0, _jquery2.default)(this).find('[type="file"]');

    $this.on('change', function () {
      var files = $input[0].files;
      var $files = (0, _jquery2.default)(this).find('.files');
      if ($files.length == 0) {
        (0, _jquery2.default)('<div class="files"></div>').insertAfter($handler);
        $files = (0, _jquery2.default)(this).find('.files');
      } else {
        // Clean the list
        $files.html('');
      }

      if (files.length == 1) {
        $files.html('<small><i class="retraitespopulaires-icon retraitespopulaires-icon-documents-thick" aria-hidden="true"></i> <span>' + files[0].name + '</span></small>');
      } else {
        for (var x = 0; x < files.length; x++) {
          $files.append('<small><i class="retraitespopulaires-icon retraitespopulaires-icon-documents-thick" aria-hidden="true"></i> <span>' + files[x].name + '</span></small>');
        }
      }
    });
  });
}

}).call(this,typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],10:[function(require,module,exports){
(function (global){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.labels = labels;

var _jquery = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function labels() {
  (0, _jquery2.default)('.list-inline').on('click', '.js-toggle-labels', function () {
    console.log((0, _jquery2.default)(this));
    (0, _jquery2.default)(this).toggleClass('collapsed').parents('.list-inline').find('.hidden').toggleClass('hidden');
  });
}

}).call(this,typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],11:[function(require,module,exports){
(function (global){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mobile_menu = mobile_menu;

var _jquery = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mobile_menu() {

  var $body = (0, _jquery2.default)('body'),
      $wrapper = (0, _jquery2.default)('#collapser-menu-toggler').parent(),
      $header = (0, _jquery2.default)('header'),
      $navbar = (0, _jquery2.default)('#mobile-menu');

  function toggleMenu() {
    if (!$wrapper.hasClass('active')) {
      $navbar.css({ 'display': 'block' });
    }

    $header.toggleClass('active');
    $wrapper.toggleClass('active');
    $navbar.toggleClass('active');

    if ($wrapper.hasClass('active')) {
      (0, _jquery2.default)('.search-box').css({ 'display': 'none' });
      (0, _jquery2.default)('.hamburger-wrapper').css({ 'display': 'flex' });
    } else {
      (0, _jquery2.default)('.search-box').css({ 'display': 'inline-flex' });
      (0, _jquery2.default)('.hamburger-wrapper').css({ 'display': '' });
    }
  }

  $wrapper.on('click', function () {
    toggleMenu();
  });

  // Close the menu when ESC is pressed
  (0, _jquery2.default)(document).keyup(function (e) {
    if (e.keyCode == 27) {
      if ($navbar.hasClass('active')) {
        toggleMenu();
      }
    }
  });

  (0, _jquery2.default)(document).on('show.bs.collapse hide.bs.collapse', function (e) {
    var $target = (0, _jquery2.default)(e.target);
    if ($target.hasClass('collapser-menu-collapse')) {
      var $parent = $target.closest('li');
      $parent.toggleClass('toggled');
    }
  });

  // Close when resizing the window
  (0, _jquery2.default)(window).on('resize', function () {
    if ($navbar.hasClass('active')) {
      toggleMenu();
    }
  });

  // Animate header-container to white background on scroll to avoid reading
  // issues. Keep it transparent at first, because of the funky waves
  var $headerContainer = (0, _jquery2.default)('.header-container');
  function animateHeaderBackground(posY) {
    if (posY > 50 && !$headerContainer.hasClass('bg-white') || posY <= 50 && $headerContainer.hasClass('bg-white')) {
      $headerContainer.toggleClass('bg-white');
    }
  }

  $navbar.on('scroll', function () {
    var posY = (0, _jquery2.default)(this).scrollTop();
    animateHeaderBackground(posY);
  });

  (0, _jquery2.default)(document).ready(function () {
    (0, _jquery2.default)('#main-navigation .collapser-first-level > .collapse').on('show.bs.collapse', function () {
      var $this = (0, _jquery2.default)(this);
      var parentCollapserFirstLevel = $this.closest('#main-navigation').children('.collapser-first-level.toggled').find('.btn');

      if (!$this.hasClass('in')) {
        parentCollapserFirstLevel.eq(0).trigger("click");
      }
    });
  });
}

}).call(this,typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],12:[function(require,module,exports){
(function (global){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.navbar = navbar;

var _jquery = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var lastScrollY = 1;

function navbar() {
  (0, _jquery2.default)(document).on('click', '.js-header-push .hamburger-wrapper, .menu-access .menu', function (e) {
    var $this = (0, _jquery2.default)(this);

    navbar_toggle();

    // Open the menu when using skip-link
    if ($this.attr('href') != '#main-navigation') {
      e.preventDefault();
    }
  });

  // Close the menu when ESC is pressed
  (0, _jquery2.default)(document).keyup(function (e) {
    if (e.keyCode == 27) {
      var $body = (0, _jquery2.default)(document.body);
      if ($body.hasClass('menu-push-toright')) {
        navbar_toggle();
      }
    }
  });

  function navbar_toggle() {
    var $body = (0, _jquery2.default)(document.body);
    var $menu = (0, _jquery2.default)('.menu-push');
    var $overlay = (0, _jquery2.default)('.body-overlay');

    $body.toggleClass('menu-push-toright');
    $menu.toggleClass('menu-open');
    $overlay.toggleClass('visible');
  }

  window.addEventListener("scroll", function () {
    var themeRP = (0, _jquery2.default)(".theme-RP")[0];
    var stickyLogo = (0, _jquery2.default)('[class^="img-sticky"]')[0];
    var headerContainer = (0, _jquery2.default)(".header-container")[0];
    var imgHeader = (0, _jquery2.default)(".logo-retraitespopulaires")[0];
    var listHeader = (0, _jquery2.default)(".wrapper-navs")[0];
    var containerMandant = (0, _jquery2.default)('[id$="-layoutheaderblock"]')[0];

    if (typeof stickyLogo == "undefined") {
      return null;
    }

    if (themeRP != undefined) {
      var header = (0, _jquery2.default)("header")[0];
      if (window.scrollY > headerContainer.clientHeight && typeof listHeader == "undefined") {
        if (lastScrollY > window.scrollY) {
          header.style.position = "fixed";
          if ((0, _jquery2.default)(document).width() > 992) {
            headerContainer.style.display = "none";
          }
          lastScrollY = window.scrollY;
        } else {
          lastScrollY = window.scrollY;
          header.style.position = "absolute";
          if ((0, _jquery2.default)(document).width() > 992) {
            headerContainer.style.display = "flex";
          }
        }
      } else {
        header.style.position = "absolute";
        headerContainer.style.display = "flex";
      }
    } else {
      if (window.scrollY > headerContainer.clientHeight && typeof listHeader == "undefined" || MandantHeaderChecker(window.scrollY, containerMandant, headerContainer)) {
        if ((0, _jquery2.default)(document).width() > 992) {
          imgHeader.style.display = "none";
          stickyLogo.style.display = "initial";
        } else {
          imgHeader.style.display = "initial";
          stickyLogo.style.display = "none";
        }
      } else {
        stickyLogo.style.display = "none";
        imgHeader.style.display = "initial";
        if (typeof listHeader !== "undefined") {
          listHeader.style.flex = "0 1 800px";
        }
      }
    }
  });

  function MandantHeaderChecker(scroll, containerMandant, headerContainer) {

    if (typeof containerMandant !== "undefined") {
      return scroll > headerContainer.clientHeight + parseInt(getComputedStyle(containerMandant).top);
    }
    return false;
  }
}

var navbarLanguage = document.getElementById("navbar-language");
var navbarLanguageClose = document.getElementById("close-language");

if (navbarLanguage != null && navbarLanguageClose != null) {
  navbarLanguage.addEventListener("click", function () {
    document.getElementById("popup-language").style.visibility = "visible";
  });

  navbarLanguageClose.addEventListener("click", function () {
    document.getElementById("popup-language").style.visibility = "hidden";
  });
}

}).call(this,typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],13:[function(require,module,exports){
(function (global){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.number_format = number_format;

var _jquery = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function number_format() {
  (0, _jquery2.default)('.form-chf-numeric').autoNumeric('init', {
    aSep: '\'',
    pSign: 's',
    aSign: ' CHF'
  });

  (0, _jquery2.default)('.form-surface-numeric').autoNumeric('init', {
    aSep: '\'',
    mDec: '0',
    pSign: 's',
    aSign: ' m2'
  });

  (0, _jquery2.default)('.form-year-numeric').autoNumeric('init', {
    aSep: '\'',
    mDec: '0',
    pSign: 's',
    aSign: ' Ans'
  });

  (0, _jquery2.default)('.form-percent-numeric').autoNumeric('init', {
    aSep: '\'',
    pSign: 's',
    aSign: ' %'
  });

  (0, _jquery2.default)('.form-separator-numeric').autoNumeric('init', {
    aSep: '\'',
    pSign: 's',
    aSign: ''
  });

  // To be sure that the format is respected (when back on browser)
  (0, _jquery2.default)('.form-chf-numeric').autoNumeric('update');
  (0, _jquery2.default)('.form-surface-numeric').autoNumeric('update');
  (0, _jquery2.default)('.form-year-numeric').autoNumeric('update');
  (0, _jquery2.default)('.form-percent-numeric').autoNumeric('update');
  (0, _jquery2.default)('.form-separator-numeric').autoNumeric('update');

  // Replace formatted value to raw one when submitting forms
  (0, _jquery2.default)(document).on('submit', 'form', function () {
    var $this = (0, _jquery2.default)(this);

    $this.find('.form-chf-numeric').each(function (i, el) {
      var $el = (0, _jquery2.default)(el);
      $el.val($el.autoNumeric('get'));
    });

    $this.find('.form-surface-numeric').each(function (i, el) {
      var $el = (0, _jquery2.default)(el);
      $el.val($el.autoNumeric('get'));
    });

    $this.find('.form-year-numeric').each(function (i, el) {
      var $el = (0, _jquery2.default)(el);
      $el.val($el.autoNumeric('get'));
    });

    $this.find('.form-percent-numeric').each(function (i, el) {
      var $el = (0, _jquery2.default)(el);
      $el.val($el.autoNumeric('get'));
    });

    $this.find('.form-separator-numeric').each(function (i, el) {
      var $el = (0, _jquery2.default)(el);
      $el.val($el.autoNumeric('get'));
    });
  });
}

}).call(this,typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],14:[function(require,module,exports){
(function (global){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.organic_generate = organic_generate;

var _jquery = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global TimelineLite, Sine */

function organic_generate() {
  (0, _jquery2.default)('.organic-lines').organicJS();
}

(function ($) {

  // jQuery Object
  $.OrganicJS = function (el, options) {
    // To avoid scope issues, use 'base' instead of 'this'
    // to reference this class from internal events and functions.
    var base = this;
    var $container = null;

    var styles = {
      'big': { size: 4, duration: 25 },
      'small': { size: 1, duration: 15 }
    };

    var patterns = [{ start: 'M1920,150 c-836, 217-1138-228-1920-8', end: 'M1920,121 C1074-171,802,527,0,0' }, { start: 'M1920,121 C1074-171,802,527,0,0', end: 'M1920,150 c-836, 217-1138-228-1920-8' }, { start: 'M1920,150 c-836, 217-500-228-1920-8', end: 'M1920,121 C500-171,802,527,0,0' }];

    // Access to jQuery and DOM versions of element
    base.$el = $(el);
    base.el = el;

    // Add a reverse reference to the DOM object
    base.$el.data('OrganicJS', base);

    base.init = function () {
      base.options = $.extend({}, $.OrganicJS.defaultOptions, options);

      base.$el.addClass('organicjs');
      $container = $('<div class="organicjs-container">');
      base.$el.append($container);

      for (var i = 0; i < base.options.big; i++) {
        var pattern = _getPattern();
        var $svg = base.generate('big', pattern.start, pattern.end);
        $container.append($svg);
      }

      for (var _i = 0; _i < base.options.small; _i++) {
        var _pattern = _getPattern();
        var _$svg = base.generate('small', _pattern.start, _pattern.end);
        $container.append(_$svg);
      }
    };

    /**
    * generate an organic line
    * @method function
    * @param  {[type]} size  [description]
    * @param  {[type]} start [description]
    * @param  {[type]} end   [description]
    * @return {[type]}       [description]
    */
    base.generate = function (size, start, end) {
      var $svg = _svg('svg', { viewBox: '0 0 1920 220', class: 'path-' + size });
      var id = _rand_id();

      var $path = _svg('path', { id: id, fill: 'none', stroke: base.options.color, 'stroke-width': styles[size].size, 'vector-effect': 'non-scaling-stroke', 'd': start });

      $svg.append($path);

      $(document).ready(function () {
        var tl = new TimelineLite();
        // let path = document.getElementById(id);
        tl.to($path, styles[size].duration, { morphSVG: end, repeat: -1, yoyo: true, ease: Sine.easeInOut });
      });

      return $svg;
    };

    /**
    * Creates svg tag, returned as jQuery object
    * @method _svg
    * @param  {[type]} tag   [description]
    * @param  {[type]} attrs [description]
    * @return {[type]}       [description]
    */
    function _svg(tag, attrs) {
      var elem = document.createElementNS('http://www.w3.org/2000/svg', tag);
      for (var k in attrs) {
        elem.setAttribute(k, attrs[k]);
      }
      return $(elem);
    }

    function _getPattern() {
      var rand = Math.random() * patterns.length | 0;
      var pattern = patterns[rand];
      patterns.splice(rand, 1);
      return pattern;
    }

    function _rand_id() {
      return Math.random().toString(36).substr(2, 10);
    }

    // Run initializer
    base.init();
  };

  $.OrganicJS.defaultOptions = {
    big: '1',
    small: '2',
    color: '#CBB900'
  };

  $.fn.organicJS = function (options) {
    return this.each(function () {
      new $.OrganicJS(this, options);
    });
  };
})(jQuery);

}).call(this,typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],15:[function(require,module,exports){
(function (global){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.popin = popin;

var _jquery = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function popin() {
  // Move popin to show on desktop
  (0, _jquery2.default)(document).on('click', '[data-toggle="popins-collapse"]', function () {
    var $this = (0, _jquery2.default)(this);

    $this.parents('.popin-container.popin-container-collapsing').find('.popin-collapse').collapse('hide');
    $this.parents('.popin-container').toggleClass('popin-container-collapse popin-container-collapsing');
  });

  // Move popin when a collapse is open
  (0, _jquery2.default)(document).on('click', '[data-toggle="collapse"]', function () {
    var $this = (0, _jquery2.default)(this);
    $this.parents('.popin-container').removeClass('popin-container-collapse').addClass('popin-container-collapsing');
  });

  // Hide current showed element on mobile
  (0, _jquery2.default)(document).on('click', '[data-toggle="popin-collapse-hide-mobile"]', function () {
    var $this = (0, _jquery2.default)(this);

    $this.parents('.popin').addClass('hidden');
    $this.parents('.popin-container').children('.popin').removeClass('show');

    var dataTarget = $this.parents('.popin').find('[data-toggle="popin-collapse-show-mobile"]').attr('data-target');
    if (dataTarget) {
      (0, _jquery2.default)(dataTarget).addClass('hidden');
    }
  });

  // Show clicked element on mobile
  (0, _jquery2.default)(document).on('click', '[data-toggle="popin-collapse-show-mobile"]', function () {
    var $this = (0, _jquery2.default)(this);
    var $currentShow = $this.parents('.popin').siblings('.show');

    if ($currentShow.length > 0) {
      $currentShow.removeClass('show');
      $currentShow.find('.popin-collapse').collapse('hide');
      var dataTarget = $currentShow.find('[data-toggle="popin-collapse-show-mobile"]').attr('data-target');
      if (dataTarget) {
        (0, _jquery2.default)(dataTarget).addClass('hidden');
      }
    }

    if ($this.attr('data-target')) {
      (0, _jquery2.default)($this.attr('data-target')).toggleClass('hidden');
    }

    $this.parents('.popin').addClass('show').children('.popin-collapse').collapse('show');
  });
}

}).call(this,typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],16:[function(require,module,exports){
(function (global){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.popover = popover;

var _jquery = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function popover() {
  (0, _jquery2.default)('[data-toggle="popover"]').popover({ trigger: 'hover' });
}

}).call(this,typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],17:[function(require,module,exports){
(function (global){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectize = selectize;

var _jquery = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function selectize() {
  var $selectize = (0, _jquery2.default)('select.selectize');
  if ($selectize.length > 0) {
    var options = (0, _jquery2.default)('select.selectize').data('options');
    $selectize.selectize({
      plugins: ['remove_button'],
      persist: false,
      render: {
        option: function option(data, escape) {
          if ((0, _jquery2.default)('select.selectize').is('[data-description]') && typeof data.description !== 'undefined') {
            return '<div>' + escape(data.name) + ' <div class="text-muted">' + escape(data.description) + '</div></div>';
          }
          return '<div>' + escape(data.name) + '</div>';
        },
        item: function item(data, escape) {
          return '<span class="selectize-item"><span>' + escape(data.name) + '</span></span>';
        }
      },
      options: options
    });
  }
}

}).call(this,typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],18:[function(require,module,exports){
(function (global){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.slider = slider;

var _jquery = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function slider() {
  (0, _jquery2.default)(document).ready(function () {
    // Check if jQuery ui is enable
    if (_jquery2.default.ui && _jquery2.default.ui.slider) {
      // Override default option for that the max value of slider is max value setted and no more value of near step
      _jquery2.default.extend(_jquery2.default.ui.slider.prototype, {
        _calculateNewMax: function _calculateNewMax() {
          this.max = this.options.max;
        }
      });

      // Add slider to each div with slider class
      (0, _jquery2.default)('.slider').generateSlider();
    }
  });
}

(function ($) {
  $.fn.generateSlider = function () {
    this.each(function (index, element) {
      // Get the JQuery element and the input with the slider
      element = $(element);

      // Get the data parameters
      var input = element.closest('.form-group').find('input');
      var currentValue = 0;
      var maxValue = Number(element.data('max'));
      var minValue = Number(element.data('min'));
      var step = Number(element.data('step'));
      var labels = element.data('labels');
      var range = 'min';
      var showPips = element.data('show-pips');
      var selected = element.data('selected-label');
      var isAutoNumeric = false;

      // Get current value from input if there's is one otherwise get from data on slider.
      if (input.length > 0 && input.val()) {
        // Verify if autoNumeric is set on this input.
        if (input.autoNumeric('getSettings')) {
          currentValue = Number(input.autoNumeric('get'));
          isAutoNumeric = true;
        } else {
          currentValue = Number(input.val());
        }
      } else {
        currentValue = Number(element.data('value'));
      }

      // To be sure that it's a number.
      if (isNaN(currentValue)) {
        currentValue = 0;
      }

      // Check if labels is an object
      if (labels && typeof labels === 'string') {
        console.error('The labels string seems to be badly declared.');
        labels = null;
      }

      // The range type can be null so set value only if undefined
      if (element.data('range') !== undefined) {
        range = element.data('range');

        // If range is null add class no-range.
        if (range === 'no-range') {
          range = null;
          element.addClass('no-range');
        }
      }

      // Init slider for this element
      element.slider({
        orientation: element.hasClass('slider-vertical') ? 'vertical' : 'horizontal',
        range: range,
        max: maxValue,
        min: minValue,
        step: step,
        value: currentValue,
        animate: 100,
        disabled: element.hasClass('disabled'),
        // For update input
        slide: function slide(event, ui) {
          // To be sure that slide don't go out of slider max value (sometimes it did when the last step wasn't a full step)
          if (ui.value > maxValue) {
            ui.value = maxValue;
          }

          if (input.length > 0) {
            isAutoNumeric ? input.autoNumeric('set', ui.value) : input.val(ui.value);
            input.change();
          }

          // Add active class to the only label
          element.children('.ui-slider-pip').removeClass('active');
          element.children('.ui-slider-pip[data-active-value="' + ui.value + '"]').addClass('active');
        }
      });

      // Show labels.
      if (labels) {
        // Add margin bottom.
        element.addClass('labels');

        for (var labelValue in labels) {
          newPips(labelValue);
        }
      }

      // Show pips on each step
      if (showPips) {
        for (var i = minValue; i <= maxValue; i += step) {
          // Only show if there's no label at the position.
          if (!labels || !labels.hasOwnProperty(i)) {
            newPips(i);
          }
        }
      }

      if (input.length > 0) {
        // Listen change event for update slider
        input.change(function () {
          var val = isAutoNumeric ? input.autoNumeric('get') : input.val();
          element.slider('value', val);
        });
      }

      // Function to generate the pips.
      function newPips(value) {
        value = Number(value);

        // Calculate the position of the pip.
        var percent = (value - minValue) / (maxValue - minValue) * 100 - 5;

        // Create pip.
        var newEl = $('<div class="ui-slider-pip" data-active-value="' + value + '"><span class="ui-slider-line"></span></div>').css('left', percent + '%');

        // If there's a label add it to the pip.
        if (labels[value]) {
          newEl.append('<span class="ui-slider-label">' + labels[value] + '</span>');
        }

        // If it is the current selected value set to active.
        if (value === currentValue) {
          newEl.addClass('active');

          // If current value is selected.
          if (selected) {
            newEl.addClass('selected');
          }
        }

        // Add the pip to the slider.
        element.append(newEl);
      }
    });
  };
})(jQuery);

}).call(this,typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],19:[function(require,module,exports){
(function (global){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.smoothscroll_load = smoothscroll_load;
exports.smoothscroll_click = smoothscroll_click;

var _jquery = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function smoothscroll_load() {
  setTimeout(function () {
    if (location.hash) {
      /* we need to scroll to the top of the window first, because the browser will always jump to the anchor first before JavaScript is ready, thanks Stack Overflow: http://stackoverflow.com/a/3659116 */
      window.scrollTo(0, 0);
      var hash = location.hash.split('#');
      smoothscroll_to((0, _jquery2.default)('#' + hash[1]));
    }
  }, 1);
}

function smoothscroll_click() {
  (0, _jquery2.default)('a[href*=#]:not([href=#])').click(function () {
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
      smoothscroll_to((0, _jquery2.default)(this.hash));
      return false;
    }
  });
}

var smoothscroll_to = function smoothscroll_to(dest) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

  var target = dest.length ? dest : (0, _jquery2.default)('[name=' + this.hash.slice(1) + ']');
  if (target.length) {
    (0, _jquery2.default)('html,body').animate({
      scrollTop: target.offset().top - offset
    }, 1000);
  }
};

}).call(this,typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}]},{},[7])